const DiseaseIcon = (props) => {
    return (
        <span className="anticon ant-menu-item-icon">
            <img src="/assets/images/Disease.svg" alt="Disease" width="24" height="24" />
        </span>
    );
};

export default DiseaseIcon;
